export default __webpack_public_path__ + "static/media/etranslator-screenshot-04.4eb98fc4.png";